export default __webpack_public_path__ + "static/media/data_setting_5.7351313c.png";